import type { UseQueryOptions } from '../../types'
import { useApi, useQuery } from '#imports'

export const useXmppConfig = (options: Omit<UseQueryOptions<any>, 'key'> = {}) => {
    const api = useApi()

    return useQuery(async () => {
        return api<any>('/gateway/ejabberd/public/xmpp-config')
    }, {
        server: false,
        ...options,
        key: 'core:xmpp:config',
    })
}
